import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useStyles } from "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CopyButton = function CopyButton(props) {
  var content = props.content,
    _onCopy = props.onCopy,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    style = props.style;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    copyId = _useState2[0],
    setCopyId = _useState2[1];
  var _useStyles = useStyles({
      theme: theme
    }),
    styles = _useStyles.styles;
  useEffect(function () {
    return function () {
      window.clearTimeout(copyId);
    };
  });
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    copied = _useState4[0],
    setCopied = _useState4[1];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(CopyToClipboard, {
      text: content && content.length ? content : '',
      onCopy: function onCopy() {
        setCopied(true);
        var tempCopyId = window.setTimeout(function () {
          setCopied(false);
        }, 2000);
        setCopyId(tempCopyId);
        if (_onCopy) _onCopy(content);
      },
      children: /*#__PURE__*/_jsxs("button", {
        type: 'button',
        disabled: copied,
        className: styles.copy,
        style: style,
        children: [/*#__PURE__*/_jsx(CopyOutlined, {
          className: classNames(styles.copyIcon, {
            scoll: copied
          })
        }), /*#__PURE__*/_jsx(CheckOutlined, {
          className: styles.copyIcon,
          style: {
            color: 'rgb(63,177,99)'
          }
        })]
      })
    })
  });
};
export default CopyButton;